'use client';

import { useTranslations } from 'next-intl';
import type React from 'react';
import { useEffect, useRef } from 'react';
import { useToast } from '@/app/components/ui/use-toast';
import { useStore } from '@/app/providers/store';
import { reportEvent } from '@/app/utils';
import { BannerRoleSection } from './BannerRoleSection';
import { QuestionSection } from './QuestionSection';
import { S1BannerMobile } from './s1-banner/S1BannerMobile';
import { S1BannerParallax } from './s1-banner/S1BannerParallax';

export const ViduStream: React.FC = () => {
  const t = useTranslations();
  const { toast } = useToast();
  const { exitNotice, clearLiveExitNotice } = useStore((s) => ({
    exitNotice: s.exitNotice,
    clearLiveExitNotice: s.clearLiveExitNotice,
  }));

  const hasReportedPvRef = useRef(false);
  useEffect(() => {
    if (hasReportedPvRef.current) return;
    hasReportedPvRef.current = true;
    reportEvent('page_view', {
      page_name: 'stream_page',
    });
  }, []);

  useEffect(() => {
    if (!exitNotice) {
      return;
    }

    toast({
      type: 'warning',
      title: exitNotice.message || t(`live.exitNotice.${exitNotice.reason}`),
    });
    clearLiveExitNotice();
  }, [clearLiveExitNotice, exitNotice, toast]);

  return (
    <div className="flex h-full w-full flex-col overflow-y-auto bg-black text-white">
      {/* 顶部静态 banner，仅作展示、不可点击。
          pb-6(24px) + BannerRoleSection 自带的 mt-6(24px) = 48px，与「官方角色」标题距「我的角色」卡片区的 pb-12(48px) 对齐 */}
      <div className="mx-auto w-full max-w-[1440px] px-8 pb-6 sm:px-0">
        {/* sm 为 max-width:767px 的反向断点，移动端/桌面端由纯 CSS 切换 */}
        <S1BannerParallax className="sm:hidden" />
        <S1BannerMobile />
      </div>

      {/* 角色区：第一格用户角色（有）/ 创建卡（无），后接官方角色。 登录/consent/claim/创建/分享等交互连同弹层已内聚到该组件。 */}
      <BannerRoleSection origin="vidu-stream" className="sm:px-0" />
      {/* FAQ Section */}
      <QuestionSection />
    </div>
  );
};
